import styled from "@emotion/styled";

import type * as auth from "@skilitics/auth-client";
import { ModalDialog } from "@skilitics/designer-ui-components";
import { useFormatMessage } from "@skilitics/localization";

import { PendingButtons } from "./PendingButtons.tsx";

export interface ResendInviteDialogProps {
  invite: auth.WorkspaceInvite;
  confirm: () => Promise<void>;
  close: () => void;
}

export const ConfirmResendInviteDialog = ({ invite, confirm, close }: ResendInviteDialogProps) => {
  const formatMessage = useFormatMessage(formatStrings);

  return (
    <ModalDialog
      open
      maxWidth="xs"
      header={formatMessage("header")}
      buttons={
        <PendingButtons
          confirmLabel={formatMessage("confirmLabel")}
          cancelLabel={formatMessage("cancelLabel")}
          confirm={confirm}
          close={close}
        />
      }
      onClose={close}
    >
      <Content>
        <p>
          {formatMessage("description", {
            email: invite.email,
          })}
        </p>
      </Content>
    </ModalDialog>
  );
};

const Content = styled.div`
  padding: 8px;
  p {
    margin: 0;
  }
`;

const formatStrings = {
  header: {
    en: "Resend Invite?",
  },
  description: {
    en: "Are you sure you want to resend the invitation message sent to {email}?",
  },
  confirmLabel: {
    en: "Yes, resend message",
  },
  cancelLabel: {
    en: "No, cancel",
  },
};
